import { logTtsPipeline } from "./tts-pipeline-log";

export type DenkerAgentVoiceStateEvent = {
  utteranceId: string;
  state: "started" | "finished" | "cancelled" | "error";
};
type DenkerAgentVoiceTerminalState = Exclude<
  DenkerAgentVoiceStateEvent["state"],
  "started"
>;
type UtteranceWaiter = {
  resolve: (state: DenkerAgentVoiceTerminalState) => void;
  timer: number;
};

const utteranceWaiters = new Map<string, UtteranceWaiter>();

export function waitForUtteranceTerminal(
  utteranceId: string,
  timeoutMs = 120_000,
): Promise<DenkerAgentVoiceTerminalState> {
  return new Promise((resolve) => {
    const timer = window.setTimeout(() => {
      utteranceWaiters.delete(utteranceId);
      logTtsPipeline(
        `playback_timeout utterance_id=${utteranceId} timeout_ms=${timeoutMs}`,
      );
      resolve("error");
    }, timeoutMs);
    utteranceWaiters.set(utteranceId, { resolve, timer });
  });
}

export function settleUtteranceWaiter(
  utteranceId: string,
  state: DenkerAgentVoiceStateEvent["state"],
): void {
  if (state === "started") return;
  const waiter = utteranceWaiters.get(utteranceId);
  if (!waiter) return;
  window.clearTimeout(waiter.timer);
  utteranceWaiters.delete(utteranceId);
  waiter.resolve(state);
}

export function dropUtteranceWaiter(utteranceId: string): void {
  const waiter = utteranceWaiters.get(utteranceId);
  if (!waiter) return;
  window.clearTimeout(waiter.timer);
  utteranceWaiters.delete(utteranceId);
}

export function resetUtteranceWaiters(): void {
  for (const waiter of utteranceWaiters.values())
    window.clearTimeout(waiter.timer);
  utteranceWaiters.clear();
}
